import React from 'react'
import About from "./sections/about/About"
import Header from "./sections/header/Header"
import Navbar from "./components/navbar/Navbar"
import Experience from './sections/experience/Experience'
import Contact from './sections/contact/Contact'
import Footer from './sections/footer/Footer'
import Project from './sections/project/Project'
import Skill from './sections/skill/Skill'

const App = () => {
  return (
    <>
        <Navbar/>
        <Header/>
        <About/>
        <Skill/>
        <Experience/>
        <Project/>
        <Contact/>
        <Footer/>
    </>
  )
}

export default App